/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import * as types from 'constants/ActionTypes';

/**
 * @typedef {{
 *   data: Partial<import("modules/offers/types").DetailedOffer>,
 *   hasChanged: boolean,
 * }} newOfferReducer,
 */

const initialState = {
  data: {
    additionalOptions: [],
    accessories: [],
    consent: {},
    id: undefined,
    dealerId: undefined,
    derivativeCode: undefined,
    discounts: [],
    features: [],
    modelId: undefined,
    status: undefined,
    tva: undefined,
    variantCode: undefined,
    vehicleTradeIn: undefined,
  },
  hasChanged: false,
};

const reducer = produce(
  /** @param {newOfferReducer} draft  */
  (draft, action) => {
    switch (action.type) {
      case types.CHANGE_OFFER: {
        let { vehicleTradeIn } = draft;
        if (action.offerProps?.vehicleTradeIn) {
          vehicleTradeIn = action.offerProps.vehicleTradeIn
            ? { ...vehicleTradeIn, ...action.offerProps.vehicleTradeIn }
            : undefined;
        }
        draft.data = { ...draft.data, ...action.offerProps, vehicleTradeIn };
        draft.hasChanged = true;
        break;
      }
      case types.COPY_OFFER_SUCCESS:
        draft.data = action.offer;
        draft.hasChanged = false;
        break;

      case types.FETCH_OFFER_FAILURE:
        draft.hasChanged = false;
        break;

      case types.FETCH_OFFER_SUCCESS:
      case types.SAVE_OFFER_SUCCESS:
        draft.data = { ...action.offer };
        draft.hasChanged = false;
        break;

      case types.RESET_NEW_OFFER:
        draft.data = initialState.data;
        draft.hasChanged = false;
        break;

      default:
    }
  },
  initialState
);
export default reducer;
